host.actions.register({
    // #region Vars
    name: '288a.commerce.orderlist.send',
    // #endregion
    // #region Entry
    async execute(data, params) {
        let tCart = data;
        if (tCart == null) {
            return this.Cancel();
        }
        let tArgs = {
            title: "Bestelliste " + tCart.cartNumber,
            message: "Möchten Sie die Bestellliste jetzt absenden?",
            successCallback: async () => {
                await this.$host.api.put(`commerce/order-lists/${tCart.cartID}/send`);
            }
        };
        return this.Window(await host.notification.showModal2("g-messages-question", tArgs));
    },
    // #endregion
});
export {};
